export default __webpack_public_path__ + "static/media/listbuilder-chat-selected.c228a555.svg";